<template>
  <div class="rank-empty">
    <img src="../../../assets/ranking/rank_empty.png">
  </div>
</template>

<script>
export default {
  name: 'Empty',
  props: {},
  created () {
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<style lang="less">
.rank-empty{
  img{
    width: 150px;
    height: 150px;
    display: block;
    padding: 50px 0;
    margin: 0 auto;
  }
}
</style>
